export const getCountryUrlPrefix: (countryPrefix: string) => string = (
  countryPrefix,
) => {
  return window.location.hostname === "localhost" ||
    window.location.pathname.includes("/dummy/")
    ? ""
    : `/${countryPrefix.toLowerCase()}`;
};
